import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { useNavigate } from 'react-router-dom';
import AdminTenantAPI from '../../api/admin/tenants.js';

const AdminImpersonation = () => {
  const navigate = useNavigate();
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit] = useState(20);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchLogs();
  }, [page, limit]);

  const fetchLogs = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await AdminTenantAPI.getImpersonationLogs({
        page,
        limit
      });
      setLogs(data.logs || []);
      setTotal(data.total || 0);
    } catch (err) {
      setError(err.message || 'Failed to load impersonation logs');
    } finally {
      setLoading(false);
    }
  };

  const nextPage = () => {
    if (page * limit < total) setPage(page + 1);
  };

  const prevPage = () => {
    if (page > 1) setPage(page - 1);
  };

  return (
    <AdminLayout>
      <div className="admin-impersonation-page" style={{ padding: '20px' }}>
        <h1>User Impersonation</h1>
        <p style={{ color: '#555', marginBottom: '20px' }}>
          Start and stop impersonation from here and review recent impersonation activity.
        </p>

        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr',
          gap: '24px'
        }}>
          <div style={{ background: '#fff', borderRadius: '8px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
            <h3 style={{ marginTop: 0 }}>Start Impersonation</h3>
            <p style={{ color: '#555' }}>
              To start impersonation, browse tenants and select a user.
            </p>
            <button
              onClick={() => navigate('/admin/tenants')}
              style={{
                padding: '10px 16px',
                background: '#3f51b5',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Go to Tenant Management
            </button>
          </div>

          <div style={{ background: '#fff', borderRadius: '8px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ margin: 0 }}>Recent Impersonation Logs</h3>
              <button
                onClick={fetchLogs}
                disabled={loading}
                style={{
                  padding: '8px 12px',
                  background: '#3f51b5',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: loading ? 'not-allowed' : 'pointer'
                }}
              >
                {loading ? 'Loading...' : 'Refresh'}
              </button>
            </div>

            {error && <div style={{ marginTop: '12px', color: '#d32f2f' }}>{error}</div>}

            <div style={{ marginTop: '16px', overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ textAlign: 'left', borderBottom: '1px solid #eee' }}>
                    <th style={{ padding: '10px' }}>Started At</th>
                    <th style={{ padding: '10px' }}>Admin</th>
                    <th style={{ padding: '10px' }}>User</th>
                    <th style={{ padding: '10px' }}>Reason</th>
                    <th style={{ padding: '10px' }}>Duration (min)</th>
                  </tr>
                </thead>
                <tbody>
                  {logs.length === 0 && !loading && (
                    <tr>
                      <td colSpan={5} style={{ padding: '12px', color: '#777' }}>
                        No impersonation activity recorded yet.
                      </td>
                    </tr>
                  )}
                  {logs.map((log) => (
                    <tr key={log.id || `${log.admin_user_id}-${log.target_user_id}-${log.started_at}`} style={{ borderBottom: '1px solid #f5f5f5' }}>
                      <td style={{ padding: '10px' }}>{log.started_at ? new Date(log.started_at).toLocaleString() : '—'}</td>
                      <td style={{ padding: '10px' }}>{log.admin_email || log.admin_user_id}</td>
                      <td style={{ padding: '10px' }}>{log.target_email || log.target_user_id}</td>
                      <td style={{ padding: '10px', maxWidth: '240px' }}>{log.reason || '—'}</td>
                      <td style={{ padding: '10px' }}>{log.duration_minutes ?? '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div style={{ marginTop: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ color: '#666' }}>
                Showing page {page} · {total} total
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button
                  onClick={prevPage}
                  disabled={page === 1 || loading}
                  style={{
                    padding: '8px 12px',
                    background: page === 1 ? '#ccc' : '#3f51b5',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: page === 1 || loading ? 'not-allowed' : 'pointer'
                  }}
                >
                  Previous
                </button>
                <button
                  onClick={nextPage}
                  disabled={page * limit >= total || loading}
                  style={{
                    padding: '8px 12px',
                    background: page * limit >= total ? '#ccc' : '#3f51b5',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: page * limit >= total || loading ? 'not-allowed' : 'pointer'
                  }}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminImpersonation;
